module.exports = __webpack_public_path__ + "img/success-icon.6d025670.png";